module.exports = __webpack_public_path__ + "static/fipcballmousemain-1ee563c061351cc1036e55f56b6cb193.jpeg";